<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <form [formGroup]="assetCreateForm" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Dimension Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div fxLayout="row">
           <!-- Solar Water Heating Section -->
            <div fxFlex>
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Solar water heating</h5>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between start">
                    <!-- Pitch -->
                    <div class="form-group" fxFlex>
                      <label for="solarWaterHeaterPitch">Pitch</label>
                      <input id="solarWaterHeaterPitch" class="form-control" formControlName="solarWaterHeaterPitch" />
                    </div>
                    <!-- Additional fields here -->
                  </div>
                </div>
              </div>
            </div>

            <!-- Store Details Section -->
            <div fxFlex>
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Store Details</h5>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between start">
                    <!-- Dedicated Solar Volume -->
                    <div class="form-group" fxFlex>
                      <label for="solarWaterHeaterDedicatedSolarVolume">Dedicated solar volume (1)</label>
                      <input id="solarWaterHeaterDedicatedSolarVolume" class="form-control" formControlName="solarWaterHeaterDedicatedSolarVolume" />
                    </div>
                    <!-- Additional fields here -->
                  </div>
                </div>
              </div>
            </div>

            <!-- Collector Details Section -->
            <div fxFlex>
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Collector Details</h5>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between start">
                    <!-- Collector Type -->
                    <div class="form-group" fxFlex>
                      <label for="solarWaterHeaterCollectorType">Collector type</label>
                      <input id="solarWaterHeaterCollectorType" class="form-control" formControlName="solarWaterHeaterCollectorType" />
                    </div>
                    <!-- Additional fields here -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>